import { Button, ButtonGroup } from "@chakra-ui/react";
import { useEffect } from "react";
import { useLangContext } from "configs/languageContext";

interface Props {
    // When true, hides French (the staff panel is ES/EN only).
    staff?: boolean;
}

// Pill-style segmented toggle: ES | EN | FR (public) or ES | EN (staff).
export const LanguageSelector = ({ staff = false }: Props) => {
    const { lang, setLang } = useLangContext();

    const ALL = [
        { key: "es", label: "ES" },
        { key: "en", label: "EN" },
        { key: "fr", label: "FR" },
    ];
    const options = staff ? ALL.filter((o) => o.key !== "fr") : ALL;

    // If a staff user lands here with FR set from a prior public-page visit,
    // quietly pull them back to ES so they don't see fallback strings.
    useEffect(() => {
        if (staff && lang === "fr") setLang("es");
    }, [staff, lang, setLang]);

    return (
        <ButtonGroup size="sm" isAttached variant="outline" borderRadius="full" overflow="hidden">
            {options.map((o, i) => {
                const active = lang === o.key;
                const isFirst = i === 0;
                const isLast = i === options.length - 1;
                return (
                    <Button
                        key={o.key}
                        onClick={() => setLang(o.key)}
                        bg={active ? "#059669" : "white"}
                        color={active ? "white" : "#0F172A"}
                        borderColor="#E2E8F0"
                        _hover={
                            active
                                ? { bg: "#047857" }
                                : { bg: "#ECFDF5", color: "#047857", borderColor: "#A7F3D0" }
                        }
                        fontWeight="700"
                        fontSize="xs"
                        letterSpacing="0.1em"
                        px={3}
                        borderLeftRadius={isFirst ? "full" : 0}
                        borderRightRadius={isLast ? "full" : 0}
                    >
                        {o.label}
                    </Button>
                );
            })}
        </ButtonGroup>
    );
};
